import React from 'react';
import { number, oneOf, shape, string } from 'prop-types';
import cx from 'classnames';
import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import SpeedTrendIcon from 'components/SpeedTrendIcon';
import SegmentIcon from 'icons/segment-small.inline.svg';
import SegmentBrokenIcon from 'icons/segment-small-broken.inline.svg';
import formatMinutesSeconds from 'helpers/formatMinutesSeconds';
import segmentStatus from 'propTypes/segmentStatus';

import styles from './segment-tooltip.scss';

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
export default function SegmentTooltip({ status, name, liveTravelTime, speedTrend }) {
  const isReporting = status !== 'disconnected';

  return (
    <Tooltip sticky offset={[5, -10]} className={cx(styles.main, styles[`status-${status}`])}>
      <TooltipItem label={isReporting ? 'travel time' : 'status'} status={status}>
        {isReporting
          ? <div className={styles.liveTravelTime}>
              {speedTrend && <SpeedTrendIcon trend={speedTrend} className={styles.trendIcon} />}
              <span className={styles.speedNumber}>
                {formatMinutesSeconds(liveTravelTime, { useClockFormat: true })}
              </span>
            </div>
          : <div className={styles.statusText}>Disconnected</div>}
      </TooltipItem>
      <TooltipItem label="segment">
        <div className={styles.segment}>
          {isReporting
            ? <SegmentIcon width={8} className={styles.segmentIcon} />
            : <SegmentBrokenIcon width={8} className={styles.segmentIcon} />}
          <div className={styles.segmentName}>
            <div>
              {name.from}
            </div>
            <div>
              {name.to}
            </div>
          </div>
        </div>
      </TooltipItem>
    </Tooltip>
  );
}

SegmentTooltip.propTypes = {
  status: segmentStatus.isRequired,
  name: shape({ to: string.isRequired, from: string.isRequired }).isRequired,
  liveTravelTime: number.isRequired,
  speedTrend: oneOf(['up', 'down']),
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/SegmentTooltip/index.js